/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/710/interface/api/cat_4396
 */
import { message } from 'ant-design-vue'
import moment from 'moment'
import { reactive, toRefs } from 'vue'
import {
  v1_portal_role_assign2Module_post,
  v1_portal_role_assign2User_post,
  v1_portal_getPermissions_post,
  v1_portal_role_getModules_post,
  v1_portal_user_list_post,
  v1_portal_user_batchRole_post,
  v1_portal_user_assignRole_post,
  v1_portal_departmentsByName_post,
  v1_portal_brower_index_post,
  v1_portal_brower_save_post
} from 'server/modules/4396' // 工作台权限管理-给模块分配角色
// 工作台权限管理-批量给用户分配角色
// 获取portal所有的权限
export const v1_portal_getPermissions_post_ = async function(params) {
  const { success, data, retInfo } = await v1_portal_getPermissions_post(params)
  if (success) {
    console.log(data)
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 工作台权限管理-通过roleId获取相关的模块

export const v1_portal_role_getModules_post_ = async function(params) {
  const { success, data, retInfo } = await v1_portal_role_getModules_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 获取钉钉所有的人员

export const v1_portal_user_list_post_ = function(state) {
  const getUserList = async () => {
    const { success, data, retInfo } = await v1_portal_user_list_post({
      ...state.params,
      ...{
        pageNum: state.pageNum,
        pageSize: state.pageSize
      }
    })
    if (success) {
      state.userDatas = data.list
      state.total = data.total
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  return {
    getUserList
  }
} // 工作台权限管理-批量给人员关联角色

export const v1_portal_user_batchRole_post_ = async function(params, close) {
  const { success, data, retInfo } = await v1_portal_user_batchRole_post(params)
  if (success) {
    close()
    message.success('批量分配成功')
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 工作台权限管理-给人员关联角色

export const v1_portal_user_assignRole_post_ = async function(params, close) {
  const { success, data, retInfo } = await v1_portal_user_assignRole_post(
    params
  )
  if (success) {
    close()
    message.success('分配成功')
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 根据部门名称搜索
export const v1_portal_departmentsByName_post_ = function(state) {
  const getUserList = async () => {
    const { success, data, retInfo } = await v1_portal_departmentsByName_post({
      ...state.params,
      ...{
        pageNum: state.pageNum,
        pageSize: state.pageSize
      }
    })
    if (success) {
      state.userDatas = data.list
      state.total = data.total
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  return {
    getUserList
  }
}

// 获取用户访问portal时上报的浏览器信息
export const v1_portal_brower_index_post_ = async function(params) {
  const { success, data, retInfo } = await v1_portal_brower_index_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 保存用户访问portal时上报的浏览器信息
export const v1_portal_brower_save_post_ = async function(params) {
  const date = moment().format('YYYY-MM-DD')
  const vuex = JSON.parse(localStorage.getItem('vuex'))
  const userName = vuex.user.userInfo.userName
  const userId = vuex.user.userInfo.userId + ''
  const local_track_flag = localStorage.getItem('track_brower_day')
  let json = {}
  if (!userId) {
    return false
  }
  if (local_track_flag) {
    json = JSON.parse(local_track_flag)
  }

  if (!local_track_flag || !json[date]) {
    const { success } = await v1_portal_brower_save_post({
      userId,
      userName,
      appVersion: navigator.userAgent
    })
    if (success) {
      localStorage.setItem(
        'track_brower_day',
        JSON.stringify({
          [date]: 1
        })
      )
    }
  }
}
